
export class Media {
  id?: string;
  url?: string;
  color?: string;
  srcset?: string;
  base64?: string;

  constructor(data: Partial<Media> = {}) {
    Object.assign(this, data)
  }
}